import { useEffect, useState } from 'react';
import { BadgeIcon } from './BadgeIcons';
import './PeakCelebration.css';

/**
 * One-time peak celebration overlay — shown when a reader first reaches the
 * top castle at 100%. Consists of:
 *  - dim backdrop
 *  - a golden crest at center with subtle bloom
 *  - shimmering leaves / balloons floating up
 *  - congratulatory Arabic text
 * Auto-dismisses after ~6s or on click.
 */
const PeakCelebration = ({ onClose }) => {
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => finish(), 6500);
    return () => clearTimeout(t);
  }, []);

  const finish = () => {
    setClosing(true);
    setTimeout(() => onClose && onClose(), 500);
  };

  // Generate 24 floating leaves with random positions/delays
  const leaves = Array.from({ length: 24 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 3,
    size: 12 + Math.random() * 18,
    duration: 5 + Math.random() * 3,
    hue: Math.random() > 0.5 ? '#e8c98b' : '#c8e6c9',
  }));

  return (
    <div className={`peak-celebration ${closing ? 'is-closing' : ''}`} onClick={finish} data-testid="peak-celebration">
      <div className="peak-backdrop" />
      <div className="peak-leaves-layer">
        {leaves.map((l) => (
          <span
            key={l.id}
            className="peak-leaf"
            style={{
              left: `${l.left}%`,
              width: `${l.size}px`,
              height: `${l.size * 1.6}px`,
              background: `linear-gradient(180deg, ${l.hue} 0%, transparent 100%)`,
              animationDelay: `${l.delay}s`,
              animationDuration: `${l.duration}s`,
            }}
          />
        ))}
      </div>

      <div className="peak-crest">
        <div className="peak-crest-glow" />
        <div className="peak-crest-icon">
          <BadgeIcon name="olive" />
        </div>
      </div>

      <div className="peak-text">
        <div className="peak-eyebrow">— بلغتَ القمة —</div>
        <h1 className="peak-title">قمة القلاع</h1>
        <p className="peak-sub">أكملتَ رحلة القلاع كلّها. وما بعد القمة أثرُ ما تقرأ.</p>
        <button type="button" onClick={finish} className="peak-dismiss" data-testid="peak-dismiss">
          استكمِل الرحلة
        </button>
      </div>
    </div>
  );
};

export default PeakCelebration;
